import buildType from '../../../services/buildType'
export default {
  state: {
    urlQuery: null,
    esanqua: buildType.apiURL('esanqua'),
    selectedPjcaList: null,
    pjcaQueueIndex: 0
  },
  mutations: {
    setPjcaPageQuery(state, payload) {
      state.urlQuery = payload
    },
    setPjcaQueue(state, payload) {
      state.selectedPjcaList = payload.list
      state.pjcaQueueIndex = payload.index
    }
  },
  actions: {},
  getters: {
    getPjcaPageQuery(state) {
      return state.urlQuery
    },
    getPjcaList(state) {
      return {
        list: state.selectedPjcaList,
        index: state.pjcaQueueIndex
      }
    }
  }
}
